import { InterfaceMonitoringRepoImpl } from "domain/repository/InterfaceMonitoring/InterfaceMonitoringRepoImpl";
import { useBankInterfaceMonitoringMaintenanceTracked } from "presentation/store/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceProvider";
import { BankInterfaceMonitoringMaintenanceVM } from "presentation/viewModel/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceVM";
import { useMemo } from "react";

export const useBankInterfaceMonitoringMaintenanceVM = () => {
    const [, setBankInterfaceMonitoringMaintenanceState] = useBankInterfaceMonitoringMaintenanceTracked();
    const bankInterfaceMonitoringMainVM = useMemo(() =>
        BankInterfaceMonitoringMaintenanceVM({
            dispatch: [setBankInterfaceMonitoringMaintenanceState],
            repo: InterfaceMonitoringRepoImpl(),
        }), [setBankInterfaceMonitoringMaintenanceState])

    return bankInterfaceMonitoringMainVM
}

